import { render, staticRenderFns } from "./TrustpilotWidget.vue?vue&type=template&id=411cd886"
import script from "./TrustpilotWidget.vue?vue&type=script&lang=js"
export * from "./TrustpilotWidget.vue?vue&type=script&lang=js"
import style0 from "./TrustpilotWidget.vue?vue&type=style&index=0&id=411cd886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports